import React, { useContext, useMemo } from "react";
import { Field, Filter, Select } from "components/commons";
import { useApi, useMount } from "hooks";
import { searchLocation } from "apis";
import { allLocationRequest, location } from "mappers";
import { mapObject, mapObjectsToSelect } from "services";
import { VenueContext } from "contexts";

const KdsFilter = ({ filterState, modifyFilter, clearFilter, onApply, fetchList }) => {
  const { venue } = useContext(VenueContext);
  const { venueId } = venue;

  const {
    request: searchLocationRequest,
    mappedData: locations = [],
    loading: loadingLocations,
  } = useApi({
    api: searchLocation,
    isArray: true,
    mapper: location,
    handleOwnError: true,
  });

  useMount(() => {
    searchLocationRequest(mapObject({ venueId }, allLocationRequest));
  });

  const outletOptions = useMemo(
    () =>
      mapObjectsToSelect(
        [...locations].sort((a, b) => a.name.localeCompare(b.name)),
        { textKey: "name", valueKey: "id" }
      ),
    [locations]
  );

  return (
    <Filter
      placeholder="Search KDS name"
      className="mb-lg"
      filterState={filterState}
      onApply={onApply}
      onClear={clearFilter}
      actionsSpan={12}
    >
      <Field filterLabel="Outlet" className="col-span-4">
        <Select
          name="outletId"
          options={outletOptions}
          loading={loadingLocations}
          value={filterState.outletId}
          placeholder="All Outlets"
          onChange={(name, { value }) => {
            const { requestState: rs } = modifyFilter(name, { value });
            fetchList(rs);
          }}
        />
      </Field>
    </Filter>
  );
};

export default KdsFilter;
